import { render, staticRenderFns } from "./InvitationLogin.vue?vue&type=template&id=b21d7e50"
import script from "./InvitationLogin.vue?vue&type=script&lang=js"
export * from "./InvitationLogin.vue?vue&type=script&lang=js"
import style0 from "./InvitationLogin.vue?vue&type=style&index=0&id=b21d7e50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports